/**
 * Language / country disclosure toggle (toolbar + footer).
 * Language links use direct locale URLs; country still uses localization-form submit.
 */
(function () {
  if (window.__topkoDisclosureInit) return;
  window.__topkoDisclosureInit = true;

  function closeAll(except) {
    document.querySelectorAll('.language-localization .disclosure, localization-form .disclosure').forEach(function (disclosure) {
      if (except && disclosure === except) return;
      var button = disclosure.querySelector('[aria-expanded]');
      var panel = disclosure.querySelector('.disclosure__list-wrapper');
      if (button) button.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('hidden', '');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.language-localization .disclosure__button, localization-form .disclosure__button');
    if (button) {
      var disclosure = button.closest('.disclosure');
      var panel = disclosure && disclosure.querySelector('.disclosure__list-wrapper');
      if (!panel) return;
      var open = button.getAttribute('aria-expanded') === 'true';
      closeAll(disclosure);
      button.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');
      }
      event.preventDefault();
      return;
    }

    // Country selector: submit localization form
    var countryLink = event.target.closest('localization-form a[data-value]');
    if (countryLink && countryLink.closest('localization-form')) {
      var form = countryLink.closest('form');
      var input = form && form.querySelector('input[name="locale_code"], input[name="country_code"]');
      if (form && input) {
        event.preventDefault();
        input.value = countryLink.getAttribute('data-value');
        form.submit();
        return;
      }
    }

    if (!event.target.closest('.disclosure')) {
      closeAll();
    }
  });

  document.addEventListener('keyup', function (event) {
    if (event.code === 'Escape') closeAll();
  });
})();
